import { initializeFpid } from '@dai-team/analytics-library'

initializeFpid(() => window.featureFlag && window.featureFlag.fpidAssignment)
